export const STARTED_NAVIGATOR_STEP_EVENT = 'Started navigator step';
export const COMPLETED_NAVIGATOR_STEP_EVENT = 'Completed navigator step';
export const STARTED_HEALTH_NAVIGATOR_EVENT = 'Started navigator';
export const COMPLETED_HEALTH_NAVIGATOR_EVENT = 'Completed navigator';
export const SELECTED_OPTION_EVENT = 'Selected option';
export const COLLECTED_CONTACT_INFO_EVENT = 'Collected Contact Info';

export const COMPLETED_HEALTH_NAVIGATOR_BACKEND_ACTION = 'track_life_health_navigator_completed';
export const STARTED_HEALTH_NAVIGATOR_BACKEND_ACTION = 'track_life_health_navigator_start';

export const SKIPPED_REFERRAL_OFFBOARD_EVENT = 'Skipped Partner Referral Offboarding';

export enum StepName {
  ASTHMA_PROFILE = 'Asthma profile',
  ADD_ADHD = 'ADD ADHD',
  ADVERSE_DRIVING_DETAILS = 'Adverse driving details',
  APPLY_ADDRESS = 'Apply address',
  APPLY_DRIVER_LICENSE = 'Apply driver license',
  APPLY_DRIVING_HISTORY = 'Apply driving history',
  APPLY_ALCOHOL_HISTORY = 'Apply alcohol history',
  APPLY_SOCIAL_SECURITY = 'Apply social security',
  APPLY_BIRTHPLACE = 'Apply birthplace',
  APPLY_EMPLOYMENT = 'Apply employment',
  APPLY_POLICY_DETAILS = 'Apply policy details',
  APPLY_APPLICATION_HISTORY = 'Apply application history',
  APPLY_REVIEW = 'Apply review',
  APPLY_CARRIER_HANDOFF = 'Apply carrier handoff',
  BLOOD_PRESSURE_PROFILE = 'Blood pressure profile',
  ANXIETY_PROFILE = 'Anxiety profile',
  BASIC_INFO = 'Basic info',
  CANCER_PROFILE = 'Cancer profile',
  CHOLESTEROL_DETAILS = 'Cholesterol details',
  CITIZENSHIP = 'Citizenship',
  CONTINUE_ONLINE = 'Continue online health profile',
  CRIMINAL_HISTORY = 'Criminal history',
  DEPRESSION_PROFILE = 'Depression profile',
  DIABETES_PROFILE = 'Diabetes profile',
  ESTIMATES = 'Estimates',
  FAMILY_HISTORY = 'Family history',
  FINANCES = 'Finances',
  HAZARDOUS_ACTIVITIES = 'Hazardous activities',
  HEALTH_LIFESTYLE = 'Health and lifestyle',
  HEALTH_PROFILE = 'Health profile',
  HEART_ATTACK_PROFILE = 'Heart attack profile',
  HOUSEHOLD_INFO = 'Household info',
  MARIJUANA_DETAILS = 'Marijuana details',
  MEDICAL_CONDITIONS = 'Medical conditions',
  MILITARY_SERVICE = 'Military service',
  MOTIVATIONS = 'Shopper question',
  MY_QUOTES = 'My quotes',
  MY_QUOTES_NEXT_STEP = 'app next steps',
  PREGNANCY_HISTORY = 'Pregnancy history',
  PRODUCT_TYPE = 'Product type',
  QUOTES_START = 'Quotes start',
  SELECT_USER = 'logged in UX',
  SLEEP_APNEA_PROFILE = 'Sleep apnea profile',
  SPOUSAL_PITCH = 'Spousal Pitch', // MLD-1 - Remove if Life Spousal Self Serve loses
  SPOUSAL_INFO = 'Spousal info', // MLD-137 - Remove if Life Spousal Self Serve 2.0 loses
  STROKE_PROFILE = 'Stroke profile',
  SUBSTANCE_USE = 'Substance use',
  TOBACCO_PROFILE = 'Tobacco profile',
  TRAVEL = 'Travel',
  // Common App
  COMMON_APP_PERSONAL_DETAILS = 'Common App Personal Details Form',
  COMMON_APP_RESIDENCE = 'Common App Residence Form',
  COMMON_APP_FINANCIAL_INFORMATION = 'Common App Financial Information Form',
  COMMON_APP_EMPLOYMENT = 'Common App Employment Form',
  COMMON_APP_APPLICATION_DETAILS = 'Common App Application Details Form',
  COMMON_APP_ADDITIONAL_COVERAGE_OPTIONS_DETAILS = 'Common App Additional Coverage Options Form',
  COMMON_APP_INSURANCE_HISTORY = 'Common App Insurance History Form',
  COMMON_APP_BENEFICIARIES = 'Common App Beneficiaries Form',
  COMMON_APP_HOUSEHOLD_INFORMATION = 'Common App Household Information Form',
  COMMON_APP_REVIEW = 'Common App Review Page',
  COMMON_APP_READ_ONLY = 'Common App Read Only Form',
  // MLD-201 - remove if Multi-Product Basic Whole Life loses
  BASIC_WHOLE_LIFE_APPLICATION = 'Basic Whole Life Application',
  // MLD-295 - remove if Digital Aquisition loses
  BEST_FOR_YOU = 'Best for you',
  BEST_FOR_YOU_COVERAGE = 'Other coverage options',
}
